"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_exports = {};
__export(types_exports, {
  MeetingStatus: () => MeetingStatus,
  RecordingState: () => RecordingState,
  RoomAccess: () => RoomAccess,
  RoomType: () => RoomType,
  TranscriptionState: () => TranscriptionState,
  recordingStateLabel: () => recordingStateLabel,
  transcriptionStateLabel: () => transcriptionStateLabel
});
module.exports = __toCommonJS(types_exports);
var RoomAccess = /* @__PURE__ */ ((RoomAccess2) => {
  RoomAccess2[RoomAccess2["Open"] = 0] = "Open";
  RoomAccess2[RoomAccess2["Knock"] = 1] = "Knock";
  RoomAccess2[RoomAccess2["DND"] = 2] = "DND";
  return RoomAccess2;
})(RoomAccess || {});
var RoomType = /* @__PURE__ */ ((RoomType2) => {
  RoomType2[RoomType2["Video"] = 0] = "Video";
  RoomType2[RoomType2["Audio"] = 1] = "Audio";
  RoomType2[RoomType2["Reception"] = 2] = "Reception";
  return RoomType2;
})(RoomType || {});
var TranscriptionState = /* @__PURE__ */ ((TranscriptionState2) => {
  TranscriptionState2[TranscriptionState2["NotStarted"] = 0] = "NotStarted";
  TranscriptionState2[TranscriptionState2["Transcribing"] = 1] = "Transcribing";
  TranscriptionState2[TranscriptionState2["Finished"] = 2] = "Finished";
  return TranscriptionState2;
})(TranscriptionState || {});
var RecordingState = /* @__PURE__ */ ((RecordingState2) => {
  RecordingState2[RecordingState2["NotStarted"] = 0] = "NotStarted";
  RecordingState2[RecordingState2["Recording"] = 1] = "Recording";
  RecordingState2[RecordingState2["Finished"] = 2] = "Finished";
  return RecordingState2;
})(RecordingState || {});
var MeetingStatus = /* @__PURE__ */ ((MeetingStatus2) => {
  MeetingStatus2[MeetingStatus2["Active"] = 0] = "Active";
  MeetingStatus2[MeetingStatus2["Finished"] = 1] = "Finished";
  MeetingStatus2[MeetingStatus2["Pending"] = 2] = "Pending";
  MeetingStatus2[MeetingStatus2["Scheduled"] = 7] = "Scheduled";
  return MeetingStatus2;
})(MeetingStatus || {});
const transcriptionStateLabel = {
  [0 /* NotStarted */]: "NotStarted",
  [1 /* Transcribing */]: "Transcribing",
  [2 /* Finished */]: "Finished"
};
const recordingStateLabel = {
  [0 /* NotStarted */]: "NotStarted",
  [1 /* Recording */]: "Recording",
  [2 /* Finished */]: "Finished"
};
//# sourceMappingURL=types.js.map
